import { EventEntry } from "../../../models";

/** Horse + rider lines for entry subcard headers (Stabling, Waivers, Entry Summary). */
export function getEntrySubCardHeaderLines(entry: EventEntry): { horseLine: string; ridersLine: string } {
    const horseLine = entry.horseName?.trim() || "Horse";
    const riderOne = entry.riderName?.trim() || "Rider";
    const riderTwo = entry.secondRiderName?.trim() || entry.secondRider?.name?.trim();
    const ridersLine = riderTwo ? `${riderOne} & ${riderTwo}` : riderOne;
    return { horseLine, ridersLine };
}

/** 0-based index in `entries` for each entry id (for consistent Entry # labels). */
export function buildEntryIndexById(entries: EventEntry[]): Map<string, number> {
    const map = new Map<string, number>();
    entries.forEach((entry, index) => {
        if (entry.id) map.set(entry.id, index);
    });
    return map;
}
